import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-simple-accordion',
  templateUrl: './simple-accordion.component.html',
  styleUrls: ['./simple-accordion.component.css']
})
export class SimpleAccordionComponent implements OnInit {

  @Input()
  id: string = 'accordionExample';

  @Input()
  header: string = 'Titulo';

  @Input()
  collapsed: boolean = true;

  constructor() { }

  ngOnInit(): void {
  }

}
